// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"a2985f7e","23":"e68a0df7","255":"b46177fd","328":"8edaf04c","367":"8b80a77b","374":"0a64ad74","704":"2addc683","750":"8d01cea5","781":"909d3573","857":"bc8d7a1d","883":"7f380d61","943":"8c65cd84"}[chunkId] + ".chunk.js";
};